<template>
  <div :class="{ 'd-flex': flex }">
    <ion-button
      :fill="question.status === 'ok' ? 'solid' : 'outline'"
      expand="block"
      size="large"
      color="primary"
      class="text-lg text-weight-bold"
      :class="{ 'w-100': block }"
      @click="setDone()"
    >
      {{ t('check-in.yes') }}
    </ion-button>
    <ion-button
      :fill="question.status !== 'ok' ? 'solid' : 'outline'"
      expand="block"
      size="large"
      color="primary"
      class="text-lg text-weight-bold mt-sm"
      :class="{ 'w-100': block }"
      @click="handleIncidence()"
    >
      No
    </ion-button>

    <ion-modal :can-dismiss="canDismiss" :is-open="isOpen">
      <ReportIncidentContent
        @cancel="onCancelReport"
        @continue="onContinue"
        :question="question"
        :show-modal="isOpen"
        :type="type"
        :booking-id="bookingId"
      />
    </ion-modal>
  </div>
</template>
<script setup lang="ts">
/* eslint-disable */
  import { IonButton, IonModal } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { ref } from 'vue';
  import ReportIncidentContent from './ReportIncidentContent.vue';
  import { GeneralQuestion } from '@/interfaces/check/check-in.interface';

  const props = withDefaults(
    defineProps<{
      question: GeneralQuestion;
      block?: boolean;
      flex?: boolean;
      type: string;
      bookingId: string;
    }>(),
    {},
  );

  const emit = defineEmits(['continue', 'cancel']);
  const isOpen = ref(false);
  const canDismiss = ref(false);
  const { t } = useI18n();

  const setOpen = (open: boolean) => (isOpen.value = open);

  const handleIncidence = () => {
    props.question.status = 'incidence';
    setOpen(true);
  };

  const setDone = () => {
    props.question.status = 'ok';
    props.question.comment = null;
  };

  const onClose = () => {
    canDismiss.value = true;
    setOpen(false);

    setTimeout(() => {
      canDismiss.value = false;
    }, 500);
  };

  const onCancelReport = () => {
    if (
      props.question.images &&
      props.question.images.length === 0 &&
      (props.question.comment === null || props.question.comment === '')
    ) {
      props.question.status = 'ok';
    }

    onClose();
  };

  const onContinue = () => {
    onClose();
    emit('continue');
  };
</script>

<style lang="scss" scoped>
  ion-modal {
    padding: 10px;
    --height: 50%;
    --border-radius: 16px;
    --box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  }

  .question-image {
    width: 100%;
    max-height: 180px;
    object-fit: contain;
  }
</style>
